import { axiosPost } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';
import { CustomAxiosResponse } from '@/api/AxiosResponse';
import { DEFAULT_DAY } from '@/lib/common/name-space';
import { now } from '@/lib/dayjs';
import { ShortenAddr, ShortenTxId } from '@/lib/Shorten';
import {
  StakeDbDashboardRequest,
  StakeDbDashboardStakeItem,
  StakeDbDashboardResponse,
} from '@/types/stake-db';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

export const readStakeDbDashboardUserList = async (
  aPayload: StakeDbDashboardRequest,
): Promise<CustomAxiosResponse<StakeDbDashboardResponse>> => {
  const payload: EndpointPayload = {
    path: '/assetfi/admin/staking/dashboard/user-list',
    body: { ...aPayload },
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  const re = await sendRequest(payload, 'readStakeDbDashboardUserList', axiosPost);
  if (re.status !== 200) {
    return re;
  }

  const mapItem = (item: any, index: number): StakeDbDashboardStakeItem => ({
    ...item,
    index,
    shortWalletAddress: ShortenAddr(item.walletAddress),
    shortTxHash: ShortenTxId(item.txHash),
    createdAt: now(item.createdAt, DEFAULT_DAY),
    fundingStartAt: now(item.fundingStartAt, DEFAULT_DAY),
    fundingEndAt: now(item.fundingEndAt, DEFAULT_DAY),
  });

  re.data = {
    stake: re.data?.stake ? re.data.stake.map(mapItem) : [],
    unstake: re.data?.unstake ? re.data.unstake.map(mapItem) : [],
    reward: re.data?.reward ? re.data.reward.map(mapItem) : [],
    withdraw: re.data?.withdraw ? re.data.withdraw.map(mapItem) : [],
  };

  return re;
};
